import { jsxs, jsx } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { memo } from "react";
import { Heading } from "../../Typography/Heading.js";
import { toStateClass } from "../../../utils/toStateClass.js";
import { Stack } from "../../Stack/Stack.js";
const FieldSet = memo(function FieldSet2({
  children,
  heading,
  isActive = false,
  // TODO: There is a CSS focus that replaces this behaviour. Remove when confirmed working.
  className,
  ...divProps
}) {
  const componentClassName = useClassNameFactory("fieldSet");
  return /* @__PURE__ */ jsxs("div", { className: componentClassName("", [toStateClass("active", isActive), className]), ...divProps, children: [
    heading !== void 0 && /* @__PURE__ */ jsx("div", { className: componentClassName("heading"), contentEditable: false, children: /* @__PURE__ */ jsx(Heading, { size: "small", children: heading }) }),
    children !== void 0 && /* @__PURE__ */ jsx(Stack, { className: componentClassName("content"), children })
  ] });
});
export {
  FieldSet
};
//# sourceMappingURL=FieldSet.js.map
